import moment from 'moment-timezone';
import * as React from 'react';
import type { TableSessionModel } from '..';
import { carbonOffsetFormat, chargingCostCostFormat, dateFormat, stopReasonMapper } from './format';

export const renderDate = (date?: string): JSX.Element =>
  date ? <span title={moment(date).toString()}>{dateFormat(date)}</span> : <></>;

export function renderStopReason({ stopReason }: TableSessionModel): string {
  return stopReasonMapper(stopReason);
}

export function renderCarbonOffset({ carbonOffset }: TableSessionModel): JSX.Element {
  return carbonOffset !== undefined ? (
    <>
      {carbonOffsetFormat(carbonOffset)} kg CO<sub>2</sub>e
    </>
  ) : (
    <></>
  );
}

export function renderChargingCost(cost: TableSessionModel['cost']): JSX.Element {
  return <>{chargingCostCostFormat(cost)}</>;
}

export function renderTotalCarbonUsage({ totalCarbonUsage }: TableSessionModel): JSX.Element {
  return totalCarbonUsage !== undefined ? (
    <>
      {totalCarbonUsage.toLocaleString(undefined, { maximumFractionDigits: 0 })} g CO<sub>2</sub>
    </>
  ) : (
    <></>
  );
}
